<template>
    <div
        :class="messageType"
        class="form-result">
        <div class="icon" />
        <h1 v-html="messageH1" />
        <p v-html="messageP" />
        <a v-if="resetButton"
           href="javascript:"
           class="btn btn-success"
           @click="$parent.resetForm()"
        >Try again</a>
    </div>
</template>

<script>
  export default {
    name: 'form-result',
    props: {
      messageType: {
        type: String,
        required: true
      },
      messageH1: {
        type: String,
        required: true
      },
      messageP: {
        type: String,
        required: true
      },
      resetButton: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
    .form-result {
        margin: 1em;
        padding: 1em 1em 2em 1em;
        background: #FFF;
        text-align: center;
        box-shadow: 4px 4px 0px rgba(0,0,0,0.1);
        border-radius: 1em;
        position: relative;

        p {
            margin-bottom: 2em;
        }

        &.success {
            border: 2px solid var(--main-success-green);
            background: linear-gradient(135deg, var(--main-success-green) 0%,var(--main-success-green) 13%,#ffffff 13%,#ffffff 13%);

            .icon:after {
                content: '✓';
            }
        }

        &.error {
            border: 2px solid var(--main-red);
            background: linear-gradient(135deg, var(--main-red) 0%,var(--main-red) 15%,#ffffff 15%,#ffffff 13%);

            .icon:after {
                content: '✗';
            }
        }

        .icon {
            position: absolute;
            left: .1em;
            top: 0.1em;
            color: #FFF;
            font-size: 3em;
            line-height: 1em;
        }
    }
</style>
